import { useMemo } from 'react';
import {
  useDeleteSpecialityMutation,
  Speciality,
} from '../api';
import { useEntityActions, BaseEntityAction } from '@hooks/useEntityActions';

// Forward declare the type to avoid circular dependency
export type SpecialityAction = BaseEntityAction;

// Define getEntityId outside to ensure stability
const getEntityId = (speciality: Speciality) => speciality.id;

export const useSpecialityActions = () => {
  const actions = useEntityActions<Speciality, SpecialityAction>({
    entityName: 'Speciality',
    displayProperty: 'title',
    deleteMutation: useDeleteSpecialityMutation,
    getEntityId,
    // 📝 To add additional actions:
    // 1. Extend SpecialityAction type: export type SpecialityAction = BaseEntityAction | 'activate' | 'archive';
    // 2. Add additionalActions config:
    // additionalActions: {
    //   activate: (speciality) => handleActivateSpeciality(speciality),
    //   archive: (speciality) => handleArchiveSpeciality(speciality),
    // },
  });

  return useMemo(() => actions, [actions]);
}; 